'use client';
import type { ForwardRefRenderFunction } from 'react';
import { forwardRef } from 'react';

import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';

import { t } from '@/utils/lang';

interface NotificationButtonProps {
    open: boolean;
    tooltipOpen: boolean;
    setTooltipOpen: (open: boolean) => void;
    onToggle: () => void;
    badgeCount?: number;
}

const NotificationButton: ForwardRefRenderFunction<
    HTMLButtonElement,
    NotificationButtonProps
> = (props, ref) => {
    const {
        open,
        tooltipOpen,
        setTooltipOpen,
        onToggle,
        badgeCount = 0,
    } = props;

    return (
        <Tooltip
            title={t('Thông báo')}
            onOpen={() => setTooltipOpen(true)}
            onClose={() => setTooltipOpen(false)}
            open={open ? false : tooltipOpen}
            PopperProps={{ className: 'capitalize' }}
        >
            <span className='inline-flex'>
                <IconButton
                    ref={ref}
                    onClick={onToggle}
                    className='!text-textPrimary'
                >
                    <Badge badgeContent={badgeCount} color='primary'>
                        <NotificationsNoneIcon />
                    </Badge>
                </IconButton>
            </span>
        </Tooltip>
    );
};

export default forwardRef(NotificationButton);
